import axios from "axios";

axios.defaults.headers.common = {
  "Content-Type": "application/json",
  Accept: "application/json, text/plain, */*"
};

const localhttp = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL
});

const schedulinghttp = axios.create({
  baseURL: process.env.VUE_APP_API_SCHEDULINGURL
});

export { localhttp, schedulinghttp };

export default localhttp;
